import type { GTM } from "./GTMInterfaces";

export function isEventOnceForSession(event: GTM.EventExtendend) {
  return event.onceForSession === true;
}
